import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=0ca024cf&scoped=true"
import script from "./ProductsForm.vue?vue&type=script&lang=js"
export * from "./ProductsForm.vue?vue&type=script&lang=js"
import style0 from "./ProductsForm.vue?vue&type=style&index=0&id=0ca024cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca024cf",
  null
  
)

export default component.exports